import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const lang = location.pathname.indexOf('/us') >= 0;
const initLang = lang ? 'en' : 'zh';

sessionStorage.setItem('mlang', initLang);
sessionStorage.setItem('plang', initLang);

export default new Vuex.Store({
  state: {
    mlang: initLang,
    plang: initLang
  },
  mutations: {
    setMLang(state, v) {
      state.mlang = v;
    },
    setPLang(state, v) {
      state.plang = v;
    }
  }
})
